import React from 'react';
import { useI18n } from '../contexts/I18nContext';

/**
 * Backend exposes X-Total-Count, X-Limit, X-Offset headers (ASCII case-insensitive).
 * Helper to extract a numeric header without crashing if it's missing.
 */
export const headerInt = (resp, name) => {
  const h = resp?.headers?.[name] ?? resp?.headers?.[name.toLowerCase()];
  const n = parseInt(h, 10);
  return Number.isFinite(n) ? n : null;
};

export default function PaginationFooter({ shown, total, onLoadMore, loading, testid }) {
  const { t } = useI18n();
  if (!shown) return null;
  const hasMore = total != null && shown < total;
  const label = total != null
    ? t('showing_n_of_m').replace('{n}', shown).replace('{m}', total)
    : `${shown}`;
  return (
    <div
      data-testid={testid}
      className="flex items-center justify-between gap-4 px-6 py-4 border-t border-stone_line bg-bg-alt/40 rounded-b-2xl"
    >
      <div className="text-xs uppercase tracking-[0.18em] text-ink-muted font-semibold">
        {label}
      </div>
      {hasMore && (
        <button
          onClick={onLoadMore}
          disabled={loading}
          data-testid={testid ? `${testid}-load-more` : 'pagination-load-more'}
          className="px-4 py-2 rounded-lg text-sm border border-stone_line bg-white text-ink hover:bg-sage-100 hover:border-sage hover:text-sage-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {loading ? t('loading') : t('load_more')}
        </button>
      )}
    </div>
  );
}
